export const ReportState = Object.freeze({
  SUBMITTED: 1,
  IN_PROCESSING: 2,
  REJECTED: 3,
  APPROVED: 4,
});
